<template>
  <el-button type="success" size="small" :loading="loading" @click="sync">
    {{ label }}
  </el-button>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'LiChengSyncButton',
  props: {
    resource: { type: String, required: true },
    label: { type: String, default: '手动同步' },
    hotelId: { type: [String, Number], default: '' },
  },
  data() { return { loading: false } },
  methods: {
    async sync() {
      let hotelId = this.hotelId
      if (['hotel_info', 'product', 'room_type', 'room_status'].includes(this.resource) && !hotelId) {
        try {
          const result = await this.$prompt('请输入丽呈酒店ID', '手动同步', {
            confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /^\d+$/, inputErrorMessage: '请输入正确的酒店ID',
          })
          hotelId = result.value
        } catch (e) { return }
      }
      this.loading = true
      try {
        const response = await request({
          url: '/api/backend/liCheng/hotel/syncResource', method: 'post',
          data: { resource: this.resource, hotel_id: hotelId || undefined },
        })
        const queued = response.data && response.data.queued ? response.data.queued : 0
        this.$message.success(queued > 0 ? '同步任务已提交' : '同步任务已在队列中')
        this.$emit('synced')
      } finally { this.loading = false }
    },
  },
}
</script>
